/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  IHeaderMethods,
  HeaderService,
  IMyProfileCardMethods,
  MyProfileCardService,
  IUpdateProfileMethods,
  UpdateProfileService
} from "./components";

export type ProfileUpdateStepperPageAgent = IStaticPageContentMethods &
  IHeaderMethods &
  IUpdateProfileMethods &
  IMyProfileCardMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new UpdateProfileService(),
    new MyProfileCardService(),
  ];
};

export const getAgent = () => {
  return createAgent<ProfileUpdateStepperPageAgent>({
    plugins: getPlugins(),
  });
};
